import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import SmoothScroll from 'smoothscroll-polyfill';

const TOP_NAVIGATION_ID = 'top-navigation';

class ScrollTo extends React.Component {
  static getOptions = ({ $target, $topNavigation, offset }) => {
    const targetRect = $target.getBoundingClientRect();
    const topNavigationRect = $topNavigation.getBoundingClientRect();
    const left = 0;
    const top = targetRect.top - topNavigationRect.height + offset + window.pageYOffset;
    const behavior = 'smooth';

    return { left, top, behavior };
  };

  static getNodes(target) {
    const $target = document.getElementById(target);
    const $topNavigation = document.getElementById(TOP_NAVIGATION_ID);

    if (!$target) {
      throw new Error(`ScrollTo: target:${target} not found!`);
    }

    if (!$topNavigation) {
      throw new Error(`ScrollTo: top navigation not found!`);
    }

    return { $target, $topNavigation };
  }

  static scroll = (target, offset) => {
    const { $target, $topNavigation } = ScrollTo.getNodes(target);
    const options = ScrollTo.getOptions({ $target, $topNavigation, offset });

    window.scrollTo(options);
  };

  static propTypes = {
    offset: PropTypes.number,
    target: PropTypes.string.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    forwardedRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.elementType }),
    ]),
  };

  static defaultProps = {
    className: '',
    offset: 0,
    onClick: () => {},
    forwardedRef: null,
  };

  componentDidMount() {
    SmoothScroll.polyfill();
  }

  render() {
    const { offset, target, children, className, onClick, forwardedRef, ...otherProps } =
      this.props;
    const classes = classNames('ScrollTo', className);

    return (
      <a
        href={`#${target}`}
        className={classes}
        ref={forwardedRef}
        onClick={event => {
          event.preventDefault();
          onClick(event);
          ScrollTo.scroll(target, offset);
        }}
        {...otherProps}
      >
        {children}
      </a>
    );
  }
}

export const Component = ScrollTo;

export default React.forwardRef((props, ref) => {
  return <ScrollTo {...props} forwardedRef={ref} />;
});
